import { NavLink } from 'react-router-dom';
import * as stylex from '@stylexjs/stylex';
import { styles } from '../styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Header = () => {
  return /*#__PURE__*/_jsxs("div", {
    ...stylex.props(styles.header),
    children: [/*#__PURE__*/_jsx(NavLink, {
      ...stylex.props(styles.link),
      to: "/",
      children: "Home"
    }), /*#__PURE__*/_jsx(NavLink, {
      ...stylex.props(styles.link),
      to: "/about",
      children: "About"
    })]
  });
};